import {
  MotifButton,
  MotifCard,
  MotifCardBody,
  MotifCardFooter,
  MotifCardHeader,
  MotifIcon,
} from '@ey-xd/motif-react';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PrivilegeForm from '../molecules/PrivilegeForm';
import iconSvg from "../../assets/icons/icon.svg.json";

const AddEditPrivilege = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { access } = useSelector((state: any) => state.user);

  const { privilegeId } = params;

  const onFormSubmit = (details) => {
    dispatch({
      type: privilegeId ? "UPDATE_PRIVILEGES" : "SAVE_PRIVILEGES", payload: {
        "privilegeName": details?.privilegeName,
        "privilegeStatus": details?.status,
        "privilegeDescription": details?.description,
        "Privilege_id": privilegeId
      }
    });
    navigate(-1)
  }

  return (
    <div className="flex flex-col min-h-full m-3">
      <MotifCard className="!bg-[transparent]">
        <MotifCardHeader className="!py-0" style={{ borderBottom: '1px solid #ffffff26' }}>
          <div className="flex gap-1 items-center !w-full">
            <MotifIcon onClick={() => navigate(-1)} src={iconSvg["arrow-left"]} className="!w-6 !py-3 cursor-pointer" />
            <h4 className='!py-3 !font-bold'>
              {state ? "Edit Privilege" : "Add new privilege"}
            </h4>
          </div>
        </MotifCardHeader>
        <MotifCardBody className="flex flex-col justify-between">
          {access.write === false ? (
            <p className="mb-5">Write access denied</p>
          ) : (
            <>
              <p className="mb-5">Please fill in below to add a new privilege:</p>
              <PrivilegeForm data={state} onCancel={() => navigate(-1)} onFormSubmit={onFormSubmit} />
            </>
          )}
        </MotifCardBody>
      </MotifCard>
    </div>
  );
};

export default AddEditPrivilege;